<template>
  <div class="privacyNotice">
    <strong>Privacy notice</strong>
    <p>
      The Department of Justice is collecting your personal information for the purpose of reviewing your 
      request under <span v-if="includeSection107 == 'true'">section 107 of</span> the <em>Births, Deaths and Marriages Registration Act 2023</em>. The information on this form may be provided to law enforcement agencies
       and to government and non-government agencies for verification of the data. Access to this information or a certificate 
       may be granted to any person who has adequate reason to obtain it, or who meets the requirements of the 
       <a target="_blank" href="https://www.publications.qld.gov.au/dataset/rbdm-policies/resource/9de92507-ca20-428f-b811-485f54ed0e70">access policy</a>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyNotice',
  props: {
    includeSection107: {
      type: String,
      required: false,
      default: '',
    }
  }
}
</script>